import {
  faBookOpen,
  faCalendarAlt,
  faClipboardList,
  faCogs,
  faGraduationCap,
  faIdCard,
  faLaptopCode,
  faUserFriends,
  faUsers,
  faUsersCog,
  faArchive,
  faFileContract,
  faHandshake,
  faPercentage,
  faFileAlt,
  faBuilding,
  faUserGraduate,
} from '@fortawesome/free-solid-svg-icons';

export const usersMenuItem = {
  link: '/users',
  name: 'Пользователи',
  icon: faUsers,
};

export const profileMenuItem = {
  link: '/profile',
  name: 'Профиль',
  icon: faIdCard,
};

export const CompaniesControlItem = {
  link: '/сompanies',
  name: 'Компании',
  icon: faBuilding,
};

export const coursesAndGroupsMenuItem = {
  link: '/courses-and-groups/',
  name: 'Курсы и группы',
  icon: faGraduationCap,
};

export const eventsMenuItem = {
  link: '/events',
  name: 'События',
  icon: faCalendarAlt,
};

export const studentWorksMenuItem = {
  link: '/student-works/',
  name: 'Работы студентов',
  icon: faLaptopCode,
};

export const materialsMenuItem = {
  link: '/materials',
  name: 'Материалы',
  icon: faBookOpen,
};

export const ESDPMenuItem = {
  link: '/esdp',
  name: 'ESDP',
  icon: faUsersCog,
};

export const archiveMenuItem = {
  link: '/archive',
  name: 'Архив',
  icon: faArchive,
};

export const SalesLeadsListItem = {
  link: 'sales/leads-list',
  name: 'Список лидов',
  icon: faUserFriends,
};

export const SalesApplicationsListItem = {
  link: 'sales/applications-list',
  name: 'Список заявок',
  icon: faFileAlt,
};

export const SalesTasksControlItem = {
  link: 'sales/tasks-control',
  name: 'Управление задачами',
  icon: faClipboardList,
};

export const SalesDiscountControlItem = {
  link: 'sales/discounts-control',
  name: 'Управление скидками',
  icon: faPercentage,
};

export const SalesPresentationControlItem = {
  link: 'sales/presentation-control',
  name: 'Управление презентациями',
  icon: faCogs,
};

export const SalesManagersControlItem = {
  link: 'sales/managers-control',
  name: 'Управление сейлз менеджерами',
  icon: faUsersCog,
};

export const SalesCoursesGroupsControlItem = {
  link: 'sales/courses-groups',
  name: 'Курсы и группы',
  icon: faGraduationCap,
};

export const SalesContractCredentialControlItem = {
  link: 'sales/contract-credentials',
  name: 'Управление контрактными данными',
  icon: faFileContract,
};

export const SalesDealsControlItem = {
  link: 'sales/deals-control',
  name: 'Управление сделками',
  icon: faHandshake,
};

export const AccountantStudentControlItem = {
  link: 'accountant/students-control',
  name: 'Студенты',
  icon: faUsers,
};

export const CompaniesCoursesAndGroupsControlItem = {
  link: 'сompanies/graduates',
  name: 'Выпускники',
  icon: faUserGraduate,
};
